export enum BusinessSectorEnum {
  TEST_1 = 'test1',
  TEST_2 = 'test2',
  TEST_3 = 'test3',
}

export const getBusinessSectorEnumValues = (): string[] => Object.values(BusinessSectorEnum);
